module.exports = __webpack_public_path__ + "static/mask-symbol-SCAG-88730dcb96c4bb9da5a79c421dbb065f.png";